export default "__VITE_ASSET__2e1408bb__"